import React from 'react';

import { ButtonProps } from 'Campaigns/Clearing/Button';

import {
    Wrapper,
    Container,
    StyledLink,
    ButtonWrapper,
    BlackLines,
    WhiteLines
} from './CtaGroup.styled';

export interface Props {
    links: (ButtonProps & { id: string })[];
    align?: 'right' | 'left';
}

const CtaGroup: React.FC<Props> = ({ links, align = 'right' }) => {
    return (
        <Wrapper $align={align}>
            <Container $align={align} $links={links}>
                {links.map((item, index) => (
                    <ButtonWrapper key={item.id}>
                        {index === 0 && (
                            <>
                                <BlackLines $align={align} /> <WhiteLines $align={align} />
                            </>
                        )}
                        <StyledLink {...item} $align={align} />
                    </ButtonWrapper>
                ))}
            </Container>
        </Wrapper>
    );
};

export default CtaGroup;
